import { render, staticRenderFns } from "./ParticipationTab.vue?vue&type=template&id=0ccafb1c"
import script from "./ParticipationTab.vue?vue&type=script&lang=js"
export * from "./ParticipationTab.vue?vue&type=script&lang=js"
import style0 from "./ParticipationTab.vue?vue&type=style&index=0&id=0ccafb1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports